import { Component, Input, OnInit } from '@angular/core';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';

@Component({
  selector: 'app-collabo-portal-change-password-sent',
  templateUrl: './collabo-portal-change-password-sent.component.html',
  styleUrls: ['./collabo-portal-change-password-sent.component.css']
})
export class CollaboPortalChangePasswordSentComponent implements OnInit {
  email: string;
  @Input()
  clientId: string;
  constructor() { }

  ngOnInit(): void {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  async passwordReset() {
    location.pathname = 'forgot-password';
  }

  async toLogin() {
    location.pathname = 'login';
  }

}
